import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { belongsTo, attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
let InvoicetaxModel = (_dec = belongsTo('invoice', {
  inverse: 'invoicetaxes',
  async: false
}), _dec2 = belongsTo('expense', {
  inverse: 'invoicetaxes',
  async: false
}), _dec3 = attr('number'), _dec4 = attr('string'), _dec5 = attr('number'), _dec6 = attr('number', {
  currency: true
}), _dec7 = attr('number', {
  currency: true
}), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec0 = attr('boolean'), _dec1 = attr('boolean'), _dec10 = attr('boolean'), _dec11 = attr('boolean'), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('number'), _dec15 = attr('boolean'), _dec16 = attr('boolean'), _dec17 = attr('string'), _dec18 = attr('number'), _dec19 = attr('string'), _dec20 = attr('number'), _dec21 = attr('boolean'), _dec22 = attr('boolean', {
  defaultValue: false
}), _class = class InvoicetaxModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "invoice", _descriptor, this);
    _initializerDefineProperty(this, "expense", _descriptor2, this);
    _initializerDefineProperty(this, "rank", _descriptor3, this);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "rate", _descriptor5, this);
    _initializerDefineProperty(this, "imponibile", _descriptor6, this);
    _initializerDefineProperty(this, "total", _descriptor7, this);
    _initializerDefineProperty(this, "is_iva", _descriptor8, this);
    _initializerDefineProperty(this, "is_rivalsa", _descriptor9, this);
    _initializerDefineProperty(this, "is_ritenuta", _descriptor0, this);
    _initializerDefineProperty(this, "is_cassa", _descriptor1, this);
    _initializerDefineProperty(this, "is_bollo", _descriptor10, this);
    _initializerDefineProperty(this, "bollo_imponibile", _descriptor11, this);
    _initializerDefineProperty(this, "type_ritenuta", _descriptor12, this);
    _initializerDefineProperty(this, "type_rivalsa", _descriptor13, this);
    _initializerDefineProperty(this, "tot_bollo", _descriptor14, this);
    _initializerDefineProperty(this, "bollo_virtuale", _descriptor15, this);
    _initializerDefineProperty(this, "bollo_cliente", _descriptor16, this);
    _initializerDefineProperty(this, "rivalsa_iva_natura", _descriptor17, this);
    _initializerDefineProperty(this, "rivalsa_iva_rate", _descriptor18, this);
    _initializerDefineProperty(this, "iva_natura", _descriptor19, this);
    _initializerDefineProperty(this, "gt", _descriptor20, this);
    _initializerDefineProperty(this, "sum", _descriptor21, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor22, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "invoice", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "expense", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "rate", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "imponibile", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "is_iva", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "is_rivalsa", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "is_ritenuta", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "is_cassa", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "is_bollo", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "bollo_imponibile", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "type_ritenuta", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "type_rivalsa", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "tot_bollo", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "bollo_virtuale", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "bollo_cliente", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "rivalsa_iva_natura", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "rivalsa_iva_rate", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "iva_natura", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "gt", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "sum", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoicetaxModel as default };
//# sourceMappingURL=invoicetax.js.map
